import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b204e644&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b204e644&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b204e644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b204e644')) {
      api.createRecord('b204e644', component.options)
    } else {
      api.reload('b204e644', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b204e644&scoped=true", function () {
      api.rerender('b204e644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/DataDheet/ReceivableBill/index.vue"
export default component.exports